import React, { useMemo } from "react";

import NewFilterForm from "./newFilterForm";
import Filter from "./filter";
import { useTranslation } from "react-i18next";
import { Report, ReportColumn, ReportFilter } from "/app/src/models";

/**
 * Renders the filters section of a report including individual filters and a new filter form.
 *
 * @param {Object} param0 - The parameters for the Filters function.
 * @param {Report} param0.report - The report data to which the filters apply.
 * @param {ReportFilter[]} param0.filters - The array of filters for the report.
 * @param {ReportColumn[]} param0.columns - The array of columns from the report.
 * @returns {JSX.Element} The JSX element representing the filters section.
 */
export default function Filters({
  report,
  filters,
  columns,
}: {
  report: Report;
  filters: ReportFilter[];
  columns: ReportColumn[];
}) {
  const { t } = useTranslation();
  const sortedFilters = useMemo(() => {
    return [...filters].sort((a, b) => a.filterGroup - b.filterGroup);
  }, [filters]);
  return (
    <div className="reportFilters">
      <h3>
        {t("translation:data")} {t("translation:filters")}
      </h3>
      {sortedFilters.map((filter) => (
        <Filter filter={filter} key={filter.id} reportColumns={columns} />
      ))}
      <NewFilterForm report={report} reportColumns={columns} />
    </div>
  );
}
